interface ViewerTeam {
  id: string;
}

type ProjectTeamResolution =
  | { kind: "resolved"; teamIds: string[] }
  | { kind: "prompt"; candidates: ViewerTeam[] };

type QuoteTeamResolution =
  | { kind: "resolved"; teamId: string | null }
  | { kind: "prompt"; candidates: ViewerTeam[] };

export function resolveProjectCreationTeams(
  viewerTeams: readonly ViewerTeam[],
  explicitSelection: string[] | null
): ProjectTeamResolution {
  if (explicitSelection !== null) {
    return { kind: "resolved", teamIds: explicitSelection };
  }
  if (viewerTeams.length === 0) return { kind: "resolved", teamIds: [] };
  if (viewerTeams.length === 1)
    return { kind: "resolved", teamIds: [viewerTeams[0].id] };
  return { kind: "prompt", candidates: [...viewerTeams] };
}

export function resolveQuoteCreationTeam(
  viewerTeams: readonly ViewerTeam[],
  explicitSelection: string | null | undefined
): QuoteTeamResolution {
  if (explicitSelection !== undefined) {
    return { kind: "resolved", teamId: explicitSelection };
  }
  if (viewerTeams.length === 0) return { kind: "resolved", teamId: null };
  if (viewerTeams.length === 1)
    return { kind: "resolved", teamId: viewerTeams[0].id };
  return { kind: "prompt", candidates: [...viewerTeams] };
}
